import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles, children }) => {
  // Retrieve userInfo from localStorage
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const userRole = userInfo.role_id;
  const fallbackPath = userRole === 4 ? "/destinations" : "/dashboard";

  if (!userRole || !allowedRoles.includes(userRole)) {
    // Redirect or you can render a "Not authorized" component here
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
